import { AppRoute } from '@app/core/routing/AppRoute';
import { DefaultStationRedirect } from '@app/core/routing/DefaultStationRedirect';
import { Switch } from 'react-router-dom';
import { ComposeCreateStationPage } from '../screens/create/ComposeCreateStationPage';
import { ComposeListStationPage } from '../screens/list/ComposeListStationPage';
import { ComposeSocialExportUploadPage } from '../screens/upload/ComposeSocialExportUploadPage';
import { ComposeEditPage } from '../screens/edit/ComposeEditPage';
import { ComposeViewPage } from '../screens/view/ComposeViewPage';

export function ComposeRoutes() {
  return (
    <Switch>
      <AppRoute exact path="/compose/s/:slug/create" component={ComposeCreateStationPage} />
      <AppRoute exact path="/compose/s/:slug" component={ComposeListStationPage} />
      <AppRoute
        path="/compose/:compositionId/upload/:platform?"
        component={ComposeSocialExportUploadPage}
      />
      <AppRoute exact path="/compose/:compositionId/edit" component={ComposeEditPage} />
      <AppRoute path="/compose/:compositionId" component={ComposeViewPage} />
      <DefaultStationRedirect to={(s) => `/compose/s/${s.slug}`} />
    </Switch>
  );
}
